<template>
  <div>
    <guide-use title="邮箱画像-私有化版本"></guide-use>
    <div class="mailbox-product-list">
      <ul class="list-header">
        <li v-for="label in labels" :key="label">{{ label }}</li>
      </ul>
      <div v-for="item in offlineProducts" :key="item.busi" class="list-body">
        <span data-label="开通时间">{{ item.ctime || '-' }}</span>
        <span data-label="截止时间">{{ item.expire || '-' }}</span>
        <span data-label="状态">{{ productStatus(item.auditflag) }}</span>
      </div>
    </div>

    <section v-if="hasActiveProduct" class="offline-records">
      <div class="records-toolbar">
        <span class="label">更新包日志</span>
        <el-date-picker
          v-model="filters.date"
          type="date"
          size="small"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
          :picker-options="pickerOptions"
          @change="filterChanged"
        ></el-date-picker>
        <span class="label">邮箱库类型</span>
        <el-select v-model="filters.mailbox_type" size="small" @change="filterChanged">
          <el-option label="后缀邮箱库" value="suffix"></el-option>
          <el-option label="完整邮箱库" value="full"></el-option>
        </el-select>
        <span class="label">更新包类型</span>
        <el-select v-model="filters.upgrade_type" size="small" @change="filterChanged">
          <el-option label="分钟级更新包" value="realtime"></el-option>
          <el-option label="每日更新包" value="upgrade"></el-option>
          <el-option label="初始全量包" value="full"></el-option>
        </el-select>
      </div>

      <div class="records-table">
        <table v-loading="loading">
          <thead>
            <tr>
              <td>更新包版本号</td>
              <td>更新时间</td>
              <td>更新源IP</td>
              <td>更新状态</td>
              <td>状态详情</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="record in records" :key="`${record.file_version}-${record.time}`">
              <td>{{ record.file_version || '-' }}</td>
              <td>{{ formatTime(record.time) }}</td>
              <td>{{ record.remote_ip || '-' }}</td>
              <td>
                <span class="record-status" :class="record.update_status">{{ statusLabel(record.update_status) }}</span>
              </td>
              <td>{{ record.status_detail || '-' }}</td>
            </tr>
            <tr v-if="!records.length">
              <td colspan="5">暂无数据</td>
            </tr>
          </tbody>
        </table>
      </div>

      <el-pagination
        v-if="total > pageSize"
        background
        layout="prev, pager, next, jumper"
        :current-page="page"
        :page-size="pageSize"
        :total="total"
        @current-change="pageChanged"
      ></el-pagination>
    </section>
  </div>
</template>

<script>
import moment from 'moment'
import GuideUse from '../../../components/mark/guideUse'
import { getMailboxOfflineRecords } from '@/services/riskMailbox'
import { productStatus } from '../utils'

export default {
  name: 'RiskMailboxOffline',
  components: { GuideUse },
  data () {
    return {
      labels: ['开通时间', '截止时间', '状态'],
      filters: {
        date: moment().format('YYYY-MM-DD'),
        mailbox_type: 'suffix',
        upgrade_type: 'realtime'
      },
      records: [],
      total: 0,
      page: 1,
      pageSize: 10,
      loading: false,
      pickerOptions: {
        disabledDate (date) {
          const today = moment().endOf('day')
          const earliest = moment().startOf('day').subtract(29, 'days')
          return moment(date).isAfter(today) || moment(date).isBefore(earliest)
        }
      }
    }
  },
  computed: {
    offlineProducts () {
      return this.$store.state.product.filter(item => item.busi === 'black_mailbox_offline')
    },
    hasActiveProduct () {
      return this.offlineProducts.some(item => item.auditflag === '5')
    }
  },
  methods: {
    productStatus,
    filterChanged () {
      this.page = 1
      this.fetchRecords()
    },
    pageChanged (page) {
      this.page = page
      this.fetchRecords()
    },
    async fetchRecords () {
      if (!this.filters.date) return
      this.loading = true
      try {
        const response = await getMailboxOfflineRecords({
          ...this.filters,
          date: `${this.filters.date}T00:00:00`,
          page: this.page,
          page_size: this.pageSize
        })
        const data = response.data || {}
        this.records = data.records || []
        this.total = data.total || 0
      } catch (error) {
        this.records = []
        this.total = 0
        this.$message.error('更新包日志加载失败')
      } finally {
        this.loading = false
      }
    },
    formatTime (value) {
      return value ? moment(value).format('YYYY-MM-DD HH:mm:ss') : '-'
    },
    statusLabel (status) {
      return {
        success: '已获取',
        no_update: '无需更新',
        failed: '未获取'
      }[status] || '未知'
    }
  },
  created () {
    if (this.hasActiveProduct) this.fetchRecords()
  }
}
</script>

<style lang="scss" scoped>
.mailbox-product-list {
  background: #fff;
  box-shadow: 0 4px 8px rgba(17, 39, 98, 0.04);
  border-radius: 4px;

  .list-header,
  .list-body {
    display: grid;
    grid-template-columns: repeat(3, minmax(150px, 1fr));

    li,
    span {
      color: #1d243c;
      text-align: center;
    }
  }

  .list-header {
    border-bottom: 1px solid #eaedf2;

    li {
      height: 58px;
      font-size: 16px;
      font-weight: 500;
      line-height: 58px;
    }
  }

  .list-body span {
    height: 75px;
    font-size: 14px;
    font-weight: 400;
    line-height: 75px;
  }
}

.offline-records {
  margin-top: 34px;

  .el-pagination {
    margin-top: 22px;
    text-align: center;
  }
}

.records-toolbar {
  display: flex;
  align-items: center;
  gap: 0;
  margin-bottom: 19px;

  .label {
    margin-right: 24px;
    color: #70778d;
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
  }

  .el-date-editor,
  .el-select {
    width: 150px;
    margin-right: 24px;
  }
}

.records-table {
  overflow-x: auto;

  table {
    width: 100%;
    min-width: 760px;
    border-collapse: collapse;
    box-shadow: 0 4px 8px rgba(17, 39, 98, 0.04);

    tr {
      background: #fff;
    }

    td {
      color: #1d243c;
      font-size: 14px;
      text-align: center;
      vertical-align: middle;
    }

    thead td {
      height: 66px;
      font-weight: 500;
    }

    tbody {
      tr:nth-of-type(odd) {
        background: #f6faff;
      }

      td {
        height: 54px;
        font-weight: 400;
      }
    }
  }
}

.record-status {
  &.success {
    color: #168f68;
  }

  &.no_update {
    color: #6f778a;
  }

  &.failed {
    color: #d8584d;
  }
}

@media (max-width: 768px) {
  .mailbox-product-list .list-header {
    display: none;
  }

  .mailbox-product-list .list-body {
    grid-template-columns: 1fr;

    span {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      width: 100%;
      height: auto;
      min-height: 54px;
      padding: 8px 12px;
      font-size: 12px;
      line-height: 20px;
      text-align: left;
      word-break: break-all;
      box-sizing: border-box;

      &::before {
        content: attr(data-label);
        flex: 0 0 64px;
        margin-right: 8px;
        color: #6f778a;
        font-size: 12px;
      }
    }
  }

  .records-toolbar {
    align-items: flex-start;
    flex-direction: column;

    .label,
    .el-date-editor.el-input,
    .el-select {
      width: 100%;
      margin: 0 0 12px;
    }
  }
}
</style>
